<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lanseedSingle',
})
</script>
<template>
        <a-form v-if="localData" :model="localData" layout="horizontal" >
          <slot name="before"></slot>
          <!--直接创建对象绑定-->
          <a-form-item :name="i" :extra="item.desc" :help="item.message"  :required="item.required" :label="item.domtype === 'hr'?'':item.name" :validate-status="item.validate"  v-for="(item,i) in localRules" :key="i" >
            <!--显示且不用修改-->
            <template v-if="item.domtype=='text'"><span class="text-grey">{{ localData[i] }}</span></template>
            <!--数字输入框-->
            <a-input-number v-else-if="item.domtype=='number'" v-model:value="localData[i]" :min="item.min" :max="item.max"  :allowClear="true" />
             <a-textarea  v-else-if="item.domtype=='textarea'"  v-model:value="localData[i]" placeholder="请输入" :rows="4"  :allowClear="true" />
            <!--数字拖动框-->
            <template v-else-if="item.domtype=='slider'">
              <a-slider v-model:value="localData[i]" :min="item.min" :max="item.max" />
            </template>
            <!--日期选择-->
            <a-date-picker v-else-if="item.domtype == 'date'" v-model:value="localData[i]" valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期"></a-date-picker>
            <!--日期时间选择-->
            <a-date-picker v-else-if="item.domtype == 'datetime'" v-model:value="localData[i]"
                valueFormat="YYYY-MM-DD HH:mm:ss" show-time placeholder="选择日期">
            </a-date-picker>
            <a-range-picker valueFormat="YYYY-MM-DD" v-else-if="item.domtype == 'datediff'" v-model:value="localData[i]" />
            <!--单项选择Radio-->
              <a-radio-group v-else-if="item.domtype == 'radio'"
                v-model:value="localData[i]">
                <a-radio style="display: block;padding:5px" v-for="(v, d) in item.data" :key="d"
                  :value="v[item.map.value]" :label="v[item.map.name]">
                  {{ v[item.map.name] }}
                  <template v-if="v.desc&&isHtml(v.desc)">
                    <a-popover title="示例" v-if="isHtml(v.desc)">
                      <InfoCircleOutlined   class="margin-left"/>
                      <div slot="content" v-html="v.desc"></div>
                    </a-popover>
                  </template>
                </a-radio>
              </a-radio-group>
              <!--开关-->
              <a-switch v-model:checked="localData[i]"
                v-else-if="item.domtype === 'switch'" placeholder="请选择">
              </a-switch>
              <!--选择器-->
              <colorpicker type="hex" v-else-if="item.domtype === 'color'" :size="item.max"  v-model:value="localData[i]"></colorpicker>
              <!--选择框-->
              <a-select v-model:value="localData[i]"
                v-else-if="item.domtype === 'select'" placeholder="请选择">
                <a-select-option :title="it[item.map.name]" :value="it[item.map.value]" v-for="(it, i) in item.data"
                  :key="i">{{ it[item.map.name] }}</a-select-option>
              </a-select>
              <!--可多选的选择框-->
              <a-select v-else-if="item.domtype === 'mutiselect'" v-model:value="localData[i]" mode="multiple" filterable placeholder="请选择">
                <a-select-option v-for="(it, i) in item.data" :key="i" :value="it[item.map.value]">
                  {{ it[item.map.name] }}
                </a-select-option>
              </a-select>
                  <!--级联选择框-->
              <a-cascader v-else-if="item.domtype === 'cascader'"  v-model:value="localData[i]" :options="item.data" :fieldNames="item.map" placeholder="Please select" />
              <!--多选框-->
              <a-checkbox-group v-model:value="localData[i]" v-else-if="item.domtype === 'checkbox'">
                <a-checkbox style="display: block;padding:5px;margin-left:0;" :value="it[item.map.value]"
                  v-for="(it, i) in item.data" :key="i">
                  <span>{{ it[item.map.name] }}</span>
                  <span v-if="it.desc" v-html="it.desc" class="text-sm text-gray margin-left"></span>
                </a-checkbox>
              </a-checkbox-group>
               <!--数据索引-->
              <template v-else-if="item.domtype === 'list'">
                <draggable :list="localData[i]" element="ul">
                  <template #item="{ element,index }">
                    <li class="flex align-center padding-sm devider">
                    <span class="flex1 margin-right">{{ element }}</span>
                    <span class="pointer padding-sm" @click="delList(i, index)">
                      <CloseCircleOutlined />
                    </span>
                  </li>
                  </template>
                </draggable>
                <div class="text-center pointer" @click="addList(i)">
                  <div class="text-gray text-center text-sm">点击添加数据</div>
                </div>
              </template>
              <!--序列-->
              <template v-else-if="item.domtype === 'tags'">
                  <LanseedTag  v-model:value="localData[i]" :max="item.max"></LanseedTag>
              </template>
              <template v-else-if="item.domtype === 'keywords'">
                  <LanseedInputselect v-model:value="localData[i]" :options="item.data" mode="multiple"  allow-clear show-search max-tag-count="responsive"></LanseedInputselect>
              </template>
              <!--自定义值-->
              <template v-else-if="item.domtype === 'keyvalue'">
                 <LanseedKeyvalue v-model:value="localData[i]" :rules="item.rules"> </LanseedKeyvalue>
              </template>
              <!--图片上传:单图-->
              <template v-else-if="item.domtype === 'img'">
                 <LanseedUploadimg v-model:value="localData[i]"></LanseedUploadimg>
              </template>
              <!--图片上传:多图-->
              <template v-else-if="item.domtype === 'imgs'">
                 <LanseedUploadimgs v-model:value="localData[i]" :max="item.max"></LanseedUploadimgs>
              </template>
               <!--视频上传:单图-->
              <template v-else-if="item.domtype === 'video'">
                 <LanseedUploadvideo v-model:value="localData[i]"></LanseedUploadvideo>
              </template>
              <!--文件上传-->
              <template v-else-if="item.domtype === 'file'">
                 <LanseedUploadfile v-model:value="localData[i]"></LanseedUploadfile>
              </template>
              <!--编辑器-->
              <template v-else-if="item.domtype === 'editor'">
                <Toolbar
                    :editor="editorRef"
                    :mode="moded"
                />
                <Editor
                    style="height: 400px;border:1px solid #ddd"
                    v-model="localData[i]"
                    :mode="moded"
                    :defaultConfig="editorConfig"
                    @onCreated="onCreated"
                />
              </template>
              <template  v-else-if="item.domtype === 'slot'" >
                    <slot :name="i" :data="localData[i]"></slot>
              </template>
              <template  v-else-if="item.domtype === 'hr'" >
                   <a-divider>{{ item.name }}</a-divider>
              </template>

              <template  v-else>
                 <a-mentions v-if="item.data&&item.data.length>0" v-model:value="localData[i]"   :options="item.data"></a-mentions>
                  <a-input v-else v-model:value="localData[i]" :allowClear="true"></a-input>
              </template>
              <!--默认文本框-->

          </a-form-item>
          <slot></slot>
          <a-from-item>
            <a-divider />
            <a-button style="width: 100%;" type="primary" @click="submit"> 确定</a-button>
          </a-from-item>
        </a-form>
</template>
<script setup lang="ts" name="lanseedSingle">

import draggable from 'vuedraggable'
import {FormType} from './formtype'
import {onMounted,defineProps,ref,watch,reactive,createVNode,onBeforeUnmount,defineComponent,shallowRef,defineEmits,watchEffect} from 'vue'
import { Modal,Input } from 'ant-design-vue'
import {DeleteOutlined,PlusOutlined,EditOutlined,CloseCircleOutlined,SearchOutlined,InfoCircleOutlined} from   '@ant-design/icons-vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {IEditorConfig } from '@wangeditor/editor'
import LanseedKeyvalue from './model/keyvalue.vue'
import LanseedInputselect from './model/inputselect.vue'
import LanseedUploadimg from './model/uploadimg.vue'
import LanseedUploadimgs from './model/uploadimgs.vue'
import LanseedUploadfile from './model/uploadfile.vue'
import LanseedTag from './TagsSelect/AddNewTag.vue'
import LanseedUploadvideo from './model/uploadvideo.vue'
import colorpicker from '@/components/lanseed/model/colorpicker.vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import {baseURL} from '@/utils/util'

const emit = defineEmits(['submit'])
var localData=reactive<object>({})
var localRules=reactive<object>({})
const editorRef=shallowRef()// 编辑器实例，必须用 shallowRef
const moded=ref('default') // default或 'simple'
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
})
const editorConfig: Partial<IEditorConfig> = {
    MENU_CONF: {
      uploadImage:{
        server:baseURL+'/Upload/UploadWangEditor',
        fieldName:'file',
        customInsert(res: any, insertFn: InsertFnType) {  // TS 语法
            if(res.state==1){
              res.data.forEach(e=>{
                insertFn(e.url, '')
              })
            }
        },
      },
      uploadVideo:{
        server:baseURL+'/Upload/UploadWangEditor',
        fieldName:'file',
        allowedFileTypes: ['video/*'],
        timeout: 60 * 1000, // 15 秒
        customInsert(res: any, insertFn: InsertFnType) {  // TS 语法
            if(res.state==1){
              res.data.forEach(e=>{
                insertFn(e.url, '')
              })
            }
        },
      }
    }
}
const onCreated = (editor) => {
      editorRef.value = editor // 记录 editor 实例，重要！
}

const defaultRule=reactive<FormType>({
  domtype:'input',
  name:'名称',
  required:false,
  data:[],
  desc:'',
  validate:'success' ,//'success' 'warning' 'error' 'validating'
  min:0,
  max:100,
  map: { name: 'text', value: 'id' },
  check:null,
  //method:null
})
const props = defineProps({
  data: {
    type: Object
  },
  rules:{
    type:Object
  }
})
const  formatRules=():void=>{
  if(props.rules){
    let lr={}
    for(var k in props.rules){
      let item =props.rules[k]
      if(item.data&&item.data.length>0){

          var ar=[]
          item.data.forEach(e => {
            if(typeof(item.data[0])=='string'){
              ar.push({id:e,text:e})
            }else{
              ar.push(1)
            }
          });
          item.data=ar
      }
      let ks=Object.assign({},defaultRule,item) as FormType
      lr[k]=ks
    }
    localRules=lr
    console.info('localRules',localRules)
  }
}
const formatData=():void=>{
  console.info('初始化时的DATA',props.data)
  for(var k in localRules){
    if(k.indexOf('.')==-1){
      //深层，没有包含.
        localData[k]=props.data[k]
    }else{
      let ks=k.split('.')
      var t=props.data
      ks.forEach(e=>{
        t=t[e]
      })
      if(t!=null){
        localData[k]=t
      }
    }

     console.info('localData',localData)
  }
}


const delList=(index:number, i:number):Event=> {
      if (typeof (localData[index]) == 'object') {
        localData[index].splice(i, 1)
      } else {
        localData[index] = []
      }

    }
const addList=(index:number):Event=> {
    var v=''
    const vnode=createVNode(Input,{placeholder: '请输入',value:v,onChange:e=> { v = e.target.value }},'')

      const m=Modal.confirm({
        title:'请输入内容',
        content:vnode ,
        onOk(){
          if(v){
            var vs = []
            if (typeof (localData[index]) === 'object') {
              vs = localData[index]
            }
            vs.push(v)
            localData[index] = vs
            }
            m.destroy()

        }
      })
    }
watchEffect(()=>{

      formatRules()
      formatData()
})
const formatOutData=()=>{
  var d={}
  for(var k in localData){
    let ks=k.split('.')

      switch(ks.length){
        case 2:
          if(!d[ks[0]]){d[ks[0]]={}}
          d[ks[0]][ks[1]]=localData[k]
          break;
        case 3:
          if(!d[ks[0]]){d[ks[0]]={}}
          if(!d[ks[0]][ks[1]]){d[ks[0]][ks[1]]={}}
          d[ks[0]][ks[1]][ks[2]]=localData[k]
          break;
        case 4:
         if(!d[ks[0]]){d[ks[0]]={}}
         if(!d[ks[0]][ks[1]]){d[ks[0]][ks[1]]={}}
         if(!d[ks[0]][ks[1]][ks[2]]){d[ks[0]][ks[1]][ks[2]]={}}

          d[ks[0]][ks[1]][ks[2]][ks[3]]=localData[k]
        break;
        default:
            d[k]=localData[k]
        break;
      }
  }
  return d
}
watch(localData,
    (n,o) => {
       if(n!=o){
          submit()
       }
    },
    {  deep: true }
)
const submit=()=>{
  console.info('提交',formatOutData(localData))
   emit('submit',formatOutData(localData))
}
onMounted(()=>{


})

</script>
<style lang="scss">
  .ant-form{padding:10px}
  .ant-form-item{padding:12px 0;margin-bottom: 0;}
</style>
